import { Component, Input, OnInit } from '@angular/core';
import { CheckPersonRulesMatrixModel } from '@bayclubs/court-booking-employee-api';

@Component({
    selector: 'app-player-rules-message',
    templateUrl: './player-rules-message.component.html',
    styleUrls: ['./player-rules-message.component.scss'],
    standalone: false
})
export class PlayerRulesMessageComponent implements OnInit {
    @Input() rules: CheckPersonRulesMatrixModel;
    @Input() categoryName: string;
    constructor() { }

    ngOnInit(): void { }

    get showRulesException() {
        return (
            this.rules &&
            (this.rules.courtBookingNotAllowed ||
                this.rules.daysAheadLimitExceeded ||
                this.rules.maxBookingsPerDayExceeded ||
                this.rules.maxMinutesPerDayExceeded ||
                this.rules.bookingPrimeTimeExceeded)
        );
    }
}
